<template>
    <div class="aviso-content card-content">
        <div class="a-img">
            <img :src="require(`@/assets/FILTROS.svg`)" alt="Home chart aviso" />
        </div>
        <div class="a-description">
            <p>Por favor, configure os filtros adequadamente para criarmos seus gráficos.</p>
            <p>Caso tenha alguma dúvida, entre em contato com nosso suporte.</p>
            <a class="el-button el-button--primary el-button--small is-round" target="_blank" rel="noopener" href="https://f360.zendesk.com/hc/pt-br" tag="button">Saiba mais</a>
        </div>
    </div>
</template>
 
 <script>
 export default {
    name: 'Aviso'
 }
 </script>
 <style lang="scss">
.aviso-content {
    padding: 15px;
    display:flex;
    .a-img {
        img {
            width: 200px;
        }
    }
    .a-description {
        font-size: 12px;
        margin-top: 50px;
        margin-left: 25px;
    }
}
 </style>
